import { Component, ElementRef, Input, ViewChild } from '@angular/core';

/**
 * Renders a single value that truncates to its cell width with an ellipsis,
 * showing the full text in a hover tooltip only when the text is actually
 * clipped. Renders nothing when `text` is empty.
 *
 * The tooltip is `position:fixed` and positioned in JS on hover so it floats
 * over the page instead of overflowing the `.logs-table-scroll` wrapper (which
 * would otherwise trigger a horizontal scrollbar into empty space).
 *
 * Relies on the global `.ellipsis-cell` / `.ellipsis-text` classes
 * (assets/css/logs.scss). Use inside a `td.flex-col` of a
 * `.logs-table.logs-table--responsive`.
 */
@Component({
  selector: 'app-ellipsis-cell',
  templateUrl: './ellipsis-cell.component.html',
})
export class EllipsisCellComponent {
  @Input() text: string | null | undefined;

  @ViewChild('txt') txt: ElementRef<HTMLElement>;

  showTooltip = false;
  tooltipTop = 0;
  tooltipLeft = 0;

  onEnter(): void {
    const el = this.txt?.nativeElement;
    if (!el || el.scrollWidth <= el.clientWidth) {
      // Not clipped → nothing to reveal.
      return;
    }
    const rect = el.getBoundingClientRect();
    // Center horizontally over the text, sit just below it (viewport coords).
    this.tooltipLeft = rect.left + rect.width / 2;
    this.tooltipTop = rect.bottom + 6;
    this.showTooltip = true;
  }

  onLeave(): void {
    this.showTooltip = false;
  }
}
